module.exports = __webpack_public_path__ + "static/media/2DGACM12.5ab605b3.jpg";